import { createSelector } from '@ngrx/store';
import { IIdentityManagementState, IRemoteXPACPortalState } from '../../utils/interfaces/store.interfaces';
import { Company, CompanyDetails } from 'src/app/generated/CrossPoint.IdentityManagement.Server';

export const selectIdentityManagement = (state: IRemoteXPACPortalState) => state.identityManagement;

export const selectDealerCompanies = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.dealerCompanies
);

export const selectInstallerCompanies = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.installerCompanies
);

export const selectRetailerCompanies = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.retailerCompanies
);

export const selectCompaniesSearch = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.allCompaniesSearch,
);

export const selectCompanyCache = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.companyCache as ReadonlyMap<string, Company>
);

export const selectCompanyInfoCache = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.companyInfoCache as ReadonlyMap<string, CompanyDetails>
);

export const selectCompany = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.selectedCompany
);

export const selectIdentityManagementPermissions = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.permission
);

export const selectCompanyPermissions = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.companyPermissions
);

export const selectUsersSearch = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.users
);

export const selectUser = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.user
);

export const selectUserDetails = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.userDetails
);

export const selectLinkedCompanies = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.linkedCompanies
);

export const selectCcapTokens = createSelector(
  selectIdentityManagement,
  (state: IIdentityManagementState) => state.ccapTokens,
);
